var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M8 0 7 1H2v2h1v15c0 1.093.907 2 2 2h8v-2H5V3h10v10h2V3h1V1h-5l-1-1zM7 5v11h2V5zm10 8v5a2 2 0 0 1-2 2h-2v-2h2v-5zm-4-8v11h-2V5z"
})));
export default SvgIconDelete;